import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { editorUrl} from 'utils/url';

export const EDITOR_FETCH_DATA_INIT = createAction('EDITOR_FETCH_DATA_INIT');
export const EDITOR_FETCH_DATA_SUCCESS = createAction('EDITOR_FETCH_DATA_SUCCESS');
export const EDITOR_FETCH_DATA_FAIL = createAction('EDITOR_FETCH_DATA_FAIL');

export const EDITOR_FETCH_SHAPE_INIT = createAction('EDITOR_FETCH_SHAPE_INIT');
export const EDITOR_FETCH_SHAPE_SUCCESS = createAction(
  'EDITOR_FETCH_SHAPE_SUCCESS'
);
export const EDITOR_FETCH_SHAPE_FAIL = createAction('EDITOR_FETCH_SHAPE_FAIL');

export const EDITOR_CLEAR_DATA = createAction('EDITOR_CLEAR_DATA');


function  createShapeLookup(shapeData) {
  const shapeLookupMap = new Map();

  if (!Array.isArray(shapeData)) {
    console.warn("Input shapeData is not an array. Returning empty map.");
    return shapeLookupMap;
  }

  for (const shape of shapeData) {
    // Ensure shape and its properties exist before trying to use them
    if (shape && typeof shape === 'object') {
      if (shape._id) {
        // Store the shape object using its ID as the key
        shapeLookupMap.set(String(shape._id), shape);
      }
      if (shape.name) {
        // Store the *same* shape object using its name as the key, plus a
        // lowercased key so name matching is case-insensitive.
        shapeLookupMap.set(shape.name, shape);
        shapeLookupMap.set(String(shape.name).trim().toLowerCase(), shape);
      }
      // Optional: If you anticipate duplicate names/IDs and need specific conflict resolution,
      // you might store an array of shapes instead of a single shape.
      // For now, it assumes IDs are unique and names should map to a single preferred shape if duplicates exist.
    }
  }
  return shapeLookupMap;
}

// propsJson is stored as a JSON string on the editor entity, but tolerate an
// already-parsed object.
function parseShapeProps(propsJson) {
  if (!propsJson) return null;
  if (typeof propsJson === 'object') return propsJson;
  if (typeof propsJson !== 'string') return null;
  try {
    return JSON.parse(propsJson);
  } catch (error) {
    console.warn('Unable to parse shape propsJson', error);
    return null;
  }
}

// Shapes/3D models carry their POI binding inside propsJson.labels[].poiId.
// Build poiId -> [shape, ...] so a POI can be resolved without relying on the
// POI's own `location`/`locations` fields.
function createPoiShapeLookup(shapeData) {
  const poiShapeMap = new Map();

  if (!Array.isArray(shapeData)) {
    console.warn('Input shapeData is not an array. Returning empty map.');
    return poiShapeMap;
  }

  for (const shape of shapeData) {
    if (!shape || typeof shape !== 'object') continue;

    const props = parseShapeProps(shape.props);
    const labels = Array.isArray(props?.labels) ? props.labels : [];

    // A shape can host several labels; collect every distinct poiId it binds to.
    const poiIds = new Set();
    for (const label of labels) {
      if (label && label.poiId) {
        poiIds.add(String(label.poiId).trim());
      }
    }
    // Some entities bind the POI directly on the entity instead of a label.
    if (shape.poiId) poiIds.add(String(shape.poiId).trim());

    for (const poiId of poiIds) {
      if (!poiId) continue;
      const existing = poiShapeMap.get(poiId);
      if (existing) {
        existing.push(shape);
      } else {
        poiShapeMap.set(poiId, [shape]);
      }
    }
  }

  return poiShapeMap;
}
export const fetchEditorData = ({
  siteId,
}) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(EDITOR_FETCH_DATA_INIT());

    console.log('fetch shape')

    if (siteId) {
      let editors;
      try {
        editors = await Axios.get(`${editorUrl}/site/open-parsed/${siteId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(EDITOR_FETCH_DATA_FAIL({ error }));
      }
      const shapes = editors.data.data.freeShapes || [];
      const model3ds = editors.data.data.model3ds || [];
      const allShapes = [...shapes, ...model3ds];
      const shapeLookUp = createShapeLookup(allShapes);
      const poiShapeLookUp = createPoiShapeLookup(allShapes);

      return dispatch(
        EDITOR_FETCH_DATA_SUCCESS({
          shapes: shapeLookUp,
          shapesByPoiId: poiShapeLookUp,
          shapeList: shapes,
          model3ds: model3ds,
        })
      );
    }
  };
};


export const clearEditorData = () => {
  return (dispatch) => {
    dispatch(EDITOR_CLEAR_DATA());
  };
};

